import type { PropsWithChildren } from 'react';

import type { LayoutContextType } from './OnboardingContext';
import OnboardingLayoutContext from './OnboardingContext';

const OnboardingProvider = ({
  value,
  children,
}: { value: LayoutContextType } & PropsWithChildren) => {
  return (
    <OnboardingLayoutContext.Provider value={value}>
      {children}
    </OnboardingLayoutContext.Provider>
  );
};

export default OnboardingProvider;
